import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import AuthShell from "@/components/auth/AuthShell";
import GoogleButton from "@/components/auth/GoogleButton";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Account created. Welcome to Buddy Solution!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Track projects, request quotes and get support."
      footer={<>Already have an account? <Link to="/login" className="font-semibold text-primary">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <Label htmlFor="r-name">Full name</Label>
          <Input id="r-name" required value={form.name} onChange={upd("name")} className="mt-1.5" data-testid="register-name" />
        </div>
        <div>
          <Label htmlFor="r-email">Email</Label>
          <Input id="r-email" type="email" required value={form.email} onChange={upd("email")} className="mt-1.5" data-testid="register-email" />
        </div>
        <div>
          <Label htmlFor="r-password">Password</Label>
          <Input id="r-password" type="password" required minLength={6} value={form.password} onChange={upd("password")} className="mt-1.5" data-testid="register-password" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label htmlFor="r-company">Company</Label><Input id="r-company" value={form.company} onChange={upd("company")} className="mt-1.5" /></div>
          <div><Label htmlFor="r-phone">Phone</Label><Input id="r-phone" value={form.phone} onChange={upd("phone")} className="mt-1.5" /></div>
        </div>
        <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="register-submit">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Create account
        </Button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-muted-foreground"><div className="h-px flex-1 bg-border" /> or <div className="h-px flex-1 bg-border" /></div>
      <GoogleButton />
    </AuthShell>
  );
}
